import { Typography, withStyles, WithStyles } from "@material-ui/core";
import React from "react";
import { IFAQSection } from "./FaqQuestions";
import { FaqItem } from "./FaqItem";
import { styles } from "./FaqView.styles";

interface IFaqSectionProps extends WithStyles<typeof styles> {
    section: IFAQSection;
}

const FaqSectionPure: React.FunctionComponent<IFaqSectionProps> = ({ classes, section }) => {
    return (
        <div className={classes.section}>
            <Typography variant="h2" gutterBottom>
                {section.name}
            </Typography>
            {section.content.map(item => (
                <FaqItem key={item.q} item={item} />
            ))}
        </div>
    );
};

export const FaqSection = withStyles(styles)(FaqSectionPure);
